// A random id for this browser, sent to our own API as X-Device-Id so Admin Settings >
// User Management can tell someone's devices apart (two iPhones on the same login, say).
// It is never used to sign anyone in, and clearing it signs nobody out.
//
// It's only sent once the server has said it accepts the header (device_tracking in the
// user data). Browsers refuse every call carrying a header the server hasn't allowed,
// so sending it to an older server would break the whole app.

const STORAGE_KEY = 'paragonDeviceId';
const VALID = /^[A-Za-z0-9-]{8,64}$/;

let serverAcceptsIt = false;
let cached = null;

const makeId = () => {
  const cryptoApi = window.crypto;
  if (cryptoApi && typeof cryptoApi.randomUUID === 'function') return cryptoApi.randomUUID();
  // randomUUID needs https (or localhost); getRandomValues works everywhere
  const bytes = new Uint8Array(16);
  cryptoApi.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
};

export const getDeviceId = () => {
  if (cached) return cached;
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id || !VALID.test(id)) {
      id = makeId();
      localStorage.setItem(STORAGE_KEY, id);
    }
    cached = id;
    return id;
  } catch (error) {
    return null;
  }
};

export const enableDeviceHeader = () => {
  serverAcceptsIt = true;
};

// Spread into the headers of calls to our own API only (never S3 or other sites).
export const deviceHeader = () => {
  if (!serverAcceptsIt) return {};
  const id = getDeviceId();
  return id ? { 'X-Device-Id': id } : {};
};
